export default __webpack_public_path__ + "static/media/conferenceImage.c2172237.svg";